/** hx-aya-v2 private conversation row (GET /private/conversations). */
export interface AyaConversationDto {
  id: string;
  org_id: string;
  title: string;
  active_leaf_message_id?: string | null;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
}

export interface AyaMessageDto {
  id: string;
  conversation_id: string;
  parent_message_id: string | null;
  role: string;
  content: string;
  model?: string | null;
  created_at: string;
}

export interface AyaLane {
  profile: 'professional';
  orgId: string;
  userId: string;
}

export type AyaConsultMode = 'quick' | 'standard' | 'deep';

export const DEFAULT_AYA_CONSULT_MODE: AyaConsultMode = 'standard';

export interface AyaRunDto {
  run_id: string;
  conversation_id: string;
  status: string;
  assistant_message_id?: string | null;
  message_id?: string | null;
  stream_url: string;
  consult_mode?: AyaConsultMode;
}

export interface AyaRunStatusDto {
  run_id: string;
  status: string;
  error?: string | null;
  assistant_message_id?: string | null;
  consult_mode?: AyaConsultMode;
}
